import { z } from 'zod';

/**
 * Os campos do cadastro de um perfil, como a tela os coleta.
 *
 * Um esquema só, usado pelo administrador editando alguém e pela pessoa editando a si
 * mesma: as duas telas mandam para casos de uso diferentes, mas o que vale como nome e
 * como e-mail não pode divergir entre elas.
 *
 * **Vazio no e-mail significa manter**, e não apagar — é a mesma regra do
 * `updateUserSchema` do núcleo. Apagar o e-mail de propósito é tirar o acesso de alguém,
 * e para isso existem desativar o perfil e revogar as sessões.
 */
export const profileFormSchema = z.object({
  name: z.string().trim().min(1, 'Nome é obrigatório.').max(120),
  email: z
    .string()
    .trim()
    .max(254)
    .refine((value) => value === '' || z.string().email().safeParse(value).success, {
      message: 'E-mail inválido.',
    }),
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;
